import logo from '../../../assets/images/logo_side_cropped.png';
import FooterList from './FooterList/FooterList';
import { footerData } from './Footer.data';
import '../../../styles/Footer.css';

export default () => {
  return (
    <footer className="footer">
      <div className="footer__header">
        <a href="/">
          <img alt='logo' className="footer__headerLogo" src={logo} />
        </a>
      </div>
      <div className="footer__main">
        {footerData.map(({ title, list }, index) => (
          <FooterList key={index} {...{ title, list }} />
        ))}
      </div>
      <div className="footer__bottom">
        <span className="footer__bottomText">
          Site web réalisé par{' '}
          <a
            className="text-primary"
            style={{ borderBottom: '1px solid var(--primary)' }}
            href="https://www.lens-group.fr/"
            target="_blank"
            rel="noreferrer">
            LENS-GROUP
          </a>
          - Copyright 2023
        </span>
      </div>
    </footer>
  );
};
